export const readTime = text => {
  if (!text) {
    return
  }
  const str = text.replace(/(<([^>]+)>)/gi, "")
  let length = Math.round(str.split(" ").length / 250)

  if (length < 2) {
    length = 2
  }

  return `${length} min read`
}
